import { LeadForm } from '@/components/LeadForm'

import {
    FLAME,
    FLAME_BG,
    FOCUS_ON_DARK,
    FORM_FIELD_CLASS,
    LANDING_PAGE,
    PRIMARY_CTA_LABEL,
    SURFACE_DARK,
} from './asesoriaTokens'

export function AsesoriaWaitlistSection() {
    return (
        <section id='plaza' className='mx-auto max-w-[1200px] scroll-mt-24 px-6 pb-20 pt-16 md:pb-28'>
            <div className={`flex flex-wrap gap-12 rounded-[28px] ${SURFACE_DARK} p-6 text-[#F5EEE4] md:p-12`}>
                <div className='flex min-w-0 flex-[1_1_340px] flex-col gap-[18px]'>
                    <div className={`text-xs font-semibold uppercase tracking-[0.14em] ${FLAME}`}>
                        Solo 1 cliente al mes
                    </div>
                    <h2 className='m-0 text-[32px] font-extrabold leading-[1.05] tracking-[-0.03em] md:text-[44px]'>
                        Déjanos tu móvil.
                    </h2>
                    <p className='m-0 text-lg text-[#A89F90]'>
                        Te llamamos esta semana para que nos cuentes tu caso. Con lo que nos digas vemos si tiene
                        sentido que trabajemos juntos. Si no, te lo decimos con sinceridad y te contamos qué haríamos en
                        tu lugar.
                    </p>
                    <p className='m-0 text-[15px] text-[#A89F90]'>
                        Te llama Samuel o Javi, del equipo de Asesoría Tipi.
                    </p>
                    <p className='m-0 text-lg font-bold'>Samuel y Javi</p>
                </div>
                <div className='min-w-0 flex-[999_1_460px] text-left [&_a]:text-[#F4502A] [&_form_p]:text-[#A89F90] [&_label]:text-[#F5EEE4]'>
                    <LeadForm
                        landingPage={LANDING_PAGE}
                        showIntroOfferOnSuccess={false}
                        successMessage='Recibido, te llamamos lo antes posible para que nos cuentes tu caso.'
                        successMessageClassName='text-[#2F9B63]'
                        defaultCallIntent='schedule'
                        submitButtonText={PRIMARY_CTA_LABEL}
                        nameFieldLabel='Tu nombre'
                        phoneFieldLabel='Teléfono'
                        roleFieldLabel='Tu rol'
                        fieldClassName={`${FORM_FIELD_CLASS} ${FOCUS_ON_DARK}`}
                        fieldLabelClassName='text-[14px] font-semibold normal-case tracking-normal text-[#F5EEE4]'
                        consentLabelClassName='text-[13px] leading-relaxed text-[#F5EEE4]'
                        consentSubtextClassName='text-[12px] leading-relaxed text-[#A89F90]'
                        submitButtonClassName={`h-[52px] rounded-full ${FLAME_BG} px-8 text-[17px] font-bold text-white shadow-[0_4px_14px_rgba(209,61,26,0.4)] ${FOCUS_ON_DARK}`}
                        formErrorClassName='text-[#F4502A]'
                        emphasizePrimaryCta
                    />
                </div>
            </div>
        </section>
    )
}
